export default __webpack_public_path__ + "static/media/favouritePeople.dda1f70f.png";